import React, { useEffect } from 'react'
import '../../assets/css/salesforce.css'

const ServiceNow = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    ServiceNow® Platform* Service
                                </h1>
                                <p className="breadcrumb-subtitle text-white">
                                    ServiceNow Professional Services include consulting, implementation, support, and related services designed to<br /> help businesses fully leverage and maximize the value of ServiceNow.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Our ServiceNow® </span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    CLOUD MIND X offers a comprehensive range of ServiceNow consulting services, including advisory, implementation, customization, testing, and ongoing support. As a specialist ServiceNow consulting partner, CLOUD MIND X leverages years of industry expertise to help organizations maximize the value of their ServiceNow platform and successfully address all related business needs.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src={require('../../assets/images/servicenow.webp')}
                                    alt="ServiceNow"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Salesforce Services Section */}
            <section className="salesforce-services-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Our <span className="text-gradient">ServiceNow Services</span>
                            </h2>
                            <p className="salesforce-services-subtitle">
                                Comprehensive ServiceNow solutions tailored to transform your business operations
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Service Card 1 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Consulting</h3>
                                <p className="sf-service-description">
                                    Expert guidance to align ServiceNow with your business goals. We analyze your processes, recommend best practices, and create a strategic roadmap for successful ServiceNow implementation and optimization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 6V18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 12H21" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Implementation</h3>
                                <p className="sf-service-description">
                                    Seamless deployment of ServiceNow tailored to your unique requirements. From setup and configuration to data migration and user training, we ensure a smooth transition and rapid adoption.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Customization</h3>
                                <p className="sf-service-description">
                                    Tailor ServiceNow to fit your business perfectly. We customize workflows, forms, and automation rules to match your specific processes and enhance productivity across your organization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="16" height="16" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 10H20" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Custom ServiceNow App Development</h3>
                                <p className="sf-service-description">
                                    Build custom applications on the ServiceNow platform. Our developers create powerful, scalable apps using GlideRecord, Script Includes, and UI Actions to extend ServiceNow functionality.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 5 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Testing</h3>
                                <p className="sf-service-description">
                                    Comprehensive testing services to ensure your ServiceNow implementation is robust and reliable. We perform functional testing, performance testing, and user acceptance testing for quality assurance.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 6 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 1V3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 21V23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 4.22L5.64 5.64" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 18.36L19.78 19.78" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1 12H3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M21 12H23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 19.78L5.64 18.36" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 5.64L19.78 4.22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Support</h3>
                                <p className="sf-service-description">
                                    Ongoing technical support to keep your ServiceNow running smoothly. We provide 24/7 assistance, regular health checks, performance optimization, and continuous improvements to maximize ROI.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 7 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 22V12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 9.5L2 12V17L12 22L22 17V12L17 9.5" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">ServiceNow Managed Services</h3>
                                <p className="sf-service-description">
                                    Full-service management of your ServiceNow platform. We handle maintenance, upgrades, monitoring, and optimization so you can focus on your core business while we ensure platform reliability.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Salesforce Clouds Expertise Section */}
            <section className="salesforce-clouds-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-3">
                            <h2 className="salesforce-clouds-title">
                                ServiceNow Products <span className="text-gradient">We Cover</span>
                            </h2>
                            <p className="salesforce-clouds-subtitle">
                                Provide a personalized ServiceNow experience that seamlessly aligns with your organization's goals and objectives.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Sales Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00D4FF" />
                                        <path d="M18 24L22 28L30 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">ITSM</h3>
                            </div>
                        </div>

                        {/* Service Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FF6B9D" />
                                        <path d="M24 14C28.4183 14 32 17.5817 32 22C32 26.4183 28.4183 30 24 30C19.5817 30 16 26.4183 16 22C16 17.5817 19.5817 14 24 14Z" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 30V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">ITOM</h3>
                            </div>
                        </div>

                        {/* Marketing Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M14 24L20 18L26 24L34 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M28 16H34V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">ITBM</h3>
                            </div>
                        </div>

                        {/* Community Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A78DFF" />
                                        <circle cx="24" cy="18" r="4" stroke="white" strokeWidth="2.5" />
                                        <circle cx="16" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                        <circle cx="32" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Security Operations</h3>
                            </div>
                        </div>

                        {/* Financial Services Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#8B5CF6" />
                                        <path d="M16 20H32M16 20V30H32V20M16 20L24 14L32 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M24 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M28 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Software Asset Management</h3>
                            </div>
                        </div>

                        {/* NonProfit Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FFA726" />
                                        <path d="M24 14L19 19V32H29V19L24 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 22H29" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Customer Service Management</h3>
                            </div>
                        </div>

                        {/* Salesforce CPQ */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A8E1" />
                                        <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 16V14M24 34V32M16 24H14M34 24H32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">HR Service Delivery</h3>
                            </div>
                        </div>

                        {/* Salesforce Commerce Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#10B981" />
                                        <path d="M16 18L20 14L24 18L28 14L32 18V30C32 31.1046 31.1046 32 30 32H18C16.8954 32 16 31.1046 16 30V18Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Now Platform App Engine</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="salesforce-contact-section">
                <div className="salesforce-contact-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="salesforce-contact-content">
                                <h2 className="salesforce-contact-title">Get in touch</h2>
                                <p className="salesforce-contact-description">
                                    Ready to turn your Salesforce solution into an efficient facilitator of long-term relationships with customers? Contact our consultants to decide what Salesforce services you need.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="salesforce-contact-btn">
                                Contact us
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default ServiceNow;